import { JSX } from "react";

import { useRootStore } from "store";
import { Icon } from "components/icon/Icon";
import { ExternalUser, ExternalUserRole } from "models/customers/customers";
import AddExternalUsers from "./AddExternalUsers";
import ListExternalUsers from "./ListExternalUsers";
import WizardModule from "../wizardmodule/WizardModule";

import "./ExternalUsersEdit.scss";

type Props = {
  showSaveButton: boolean;
  onSaveClick: () => void;
  externalUsers: ExternalUser[];
  onItemAdded: (user: Partial<ExternalUser>, isNew?: boolean) => void;
  onItemRemove: (email: string) => void;
  resetValidUserData?: () => void;
  info?: string | JSX.Element;
  collapsed?: boolean;
};

export default function ExternalUsersEdit({
  showSaveButton,
  onSaveClick,
  externalUsers,
  onItemAdded,
  onItemRemove,
  resetValidUserData,
  info,
  collapsed
}: Props) {
  const { isLoading } = useRootStore((state) => state.wizard);

  let list;
  let errorContainer;
  if (externalUsers.length > 0) {
    list = (
      <ListExternalUsers
        onItemRemove={onItemRemove}
        listItems={externalUsers}
      />
    );
  }

  if (
    externalUsers.length > 0 &&
    externalUsers.filter((u) => u.roles.includes(ExternalUserRole.Admin)).length === 0
  ) {
    errorContainer = (
      <div className="error">
        <Icon name="exclamation-circle" size="lg" />
        <span>Det måste finnas en kundadmin.</span>
      </div>
    );
  }

  return (
    <WizardModule
      showSaveButton={showSaveButton}
      onSaveClick={onSaveClick}
      collapsed={collapsed}
      moduleTitle="Kundanvändare"
      info={info}
    >
      <>
        {list}
        {errorContainer}
        {!isLoading &&
          <AddExternalUsers
            itemAdded={onItemAdded}
            selectedUsers={externalUsers}
            resetValidUserData={resetValidUserData}
          />
        }
      </>
    </WizardModule>
  );
}